import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthoringList } from "@/features/courses/components/authoring/authoring-list";

export const authoringRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/authoring",
  component: AuthoringList,
});
